import type { FC, ReactEventHandler } from "react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import LoadingOverlay from "@/components/LoadingOverlay";
import useTitle from "@/hooks/useTitle";
import { getExternalSrcPath } from "@/routerConfig/router.helpers";

const StyledIframe = styled("iframe")({
  display: "block",
  width: "100%",
  border: 0,
  overflow: "visible",
  minHeight: "var(--app-main-height)",
});

const StyledContainer = styled("div")({
  position: "relative",
});

type ExternalPageProps = {
  title: string;
  path: string;
};

const ExternalPage: FC<ExternalPageProps> = ({ title, path }) => {
  useTitle(title);

  const [loaded, setLoaded] = useState(false);
  const { pathname } = useLocation();
  // not including location search for now, see PR-2453
  const srcPath = getExternalSrcPath(pathname || path);

  useEffect(() => {
    setLoaded(false);
  }, [srcPath]);

  // Handle loading with an overlay that hides the ugly "Loading Nimbus..."
  // NOTE: loaded state reverts to false on HMR while the iframe content remains loaded
  const onLoad: ReactEventHandler<HTMLIFrameElement> = () => {
    setLoaded(true);
  };

  return (
    <StyledContainer>
      <StyledIframe title="main page content" src={srcPath} onLoad={onLoad} />
      <LoadingOverlay loaded={loaded} />
    </StyledContainer>
  );
};

export default ExternalPage;
